import { render, staticRenderFns } from "./VuesticBreadcrumbs.vue?vue&type=template&id=eb6592e8"
import script from "./VuesticBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./VuesticBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./VuesticBreadcrumbs.vue?vue&type=style&index=0&id=eb6592e8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb6592e8')) {
      api.createRecord('eb6592e8', component.options)
    } else {
      api.reload('eb6592e8', component.options)
    }
    module.hot.accept("./VuesticBreadcrumbs.vue?vue&type=template&id=eb6592e8", function () {
      api.rerender('eb6592e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-breadcrumbs/VuesticBreadcrumbs.vue"
export default component.exports